import React from 'react';

class UserRow extends React.Component {
    render() {
	var user = this.props.user;
	
	return (
	    <tr>
		<td>{user.firstname} {user.lastname}</td>
		<td>{user.year}</td>
		<td>{user.troop}</td>
		<td>{user.email}</td>
		<td>{user.team}</td>
	    </tr>
	);
    }
}

export default UserRow;
